import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem("cb_consent")) setShow(true);
    } catch {
      /* private mode */
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem("cb_consent", "1");
    } catch { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;

  return (
    <motion.div
      data-testid="cookie-consent-banner"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 1 }}
      className="fixed bottom-20 left-4 right-4 z-[65] border border-gold/25 bg-obsidian/95 p-5 backdrop-blur-xl sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-sm"
    >
      <p className="text-xs leading-relaxed text-steel">
        We use essential storage and privacy-respecting analytics to improve your experience. By
        continuing, you agree to our{" "}
        <Link to="/privacy-policy" className="text-gold underline underline-offset-2" data-testid="cookie-privacy-link">
          Privacy Policy
        </Link>
        .
      </p>
      <button
        data-testid="cookie-accept-btn"
        onClick={accept}
        className="mt-4 w-full bg-gold px-4 py-2.5 text-[11px] font-bold uppercase tracking-[0.2em] text-obsidian transition-colors duration-300 hover:bg-gold-soft"
      >
        Accept & Continue
      </button>
    </motion.div>
  );
};
